import { Button, Card, CardActions, CardMedia, Container, Link, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { WebStorageService } from "../services/WebStorageService";
import { Order } from "../models/Order";

export default function OrderNowStep4() {
    const [voucherCode, setVoucherCode] = useState();
    const [fullName, setFullName] = useState('Randy Venturina');

    const [hasError, setHasError] = useState(false);
    const [message, setMessage] = useState("");
    const navigate = useNavigate();
    const ORDER_NOW = "ORDER_NOW";
    const webStorageService = new WebStorageService();
    let order:Order = webStorageService.getJson(ORDER_NOW);

    function onVoucherCodeChange(event: any) {
        setVoucherCode(event.target.value);
    }
    function onOrderAgain() {
        navigate("/order-now-step1")
    }

    return (
        <Container>
            <Card sx={{ marginTop:15, background:"#FEF9F8", maxWidth:400, marginX:"auto", boxShadow:{xs:'none', md:'var(--Paper-shadow)'} }}>
                <CardMedia
                    sx={{ height: 250 }}
                    image="celebrating.png"
                />
                    <Typography variant="subtitle2" textAlign="center" marginTop={3}>
                        Hi <b>{order.FirstName} {order.LastName}</b>, ang aming sales representative ay makikipag-ugnayan po sa inyo sa ilang sandali. Maraming salamat po sa inyong pagtangkilik. 
                    </Typography>
                    <Typography variant="subtitle2" textAlign="center" marginTop={3}>
                        Ang inyong order Reference Number ay 
                            <Typography variant="h3" sx={{letterSpacing:5, fontFamily:"Courier New", textAlign:"center", textShadow: "2px 2px 4px #000000" }}>
                                {order.OrderID?.toString()}
                            </Typography>    
                        
                    </Typography>
                
                
                <CardActions sx={{display:"flex", justifyContent:"space-between", marginTop:5, marginBottom:2}}>
                    <Link href="/home" variant="body2" sx={{display:"flex", alignItems:"center", textDecoration: "none" }}>GO HOME</Link>
                    <Button variant="contained" sx={{background:"#d32f2f"}} onClick={onOrderAgain} size="large">Order again</Button>
                </CardActions>
            </Card>
        </Container>
    );
}